define('evicommon/pagination.util',['require','exports','module','underscore','./spf/model/paginate','./spf/model/sort','./spf/spf.helper','./spf/paginate.adapter','./spf/sort.adapter'],function(require, exports, module){
  var _               = require('underscore');
  var Paginate        = require('./spf/model/paginate');
  var Sort            = require('./spf/model/sort');
  var SPFHelper       = require('./spf/spf.helper');
  var PaginateAdapter = require('./spf/paginate.adapter');
  var SortAdapter     = require('./spf/sort.adapter');

  var PaginationUtil = {

    createSpfHelper: function(collection, options) {
      return new SPFHelper(collection, options);
    },

    createPaginate: function(attrs, options) {
      return new Paginate(attrs, options);
    },

    createPaginateAdapter: function(model, options) {
      return new PaginateAdapter(model, options);
    },

    createSort: function(attrs, options) {
      return new Sort(attrs, options);
    },

    createSortCollection: function() {
      return new Sort.Collection();
    },

    createSortWithField: function(field, options) {
      return Sort.createWithField(field, options);
    },

    createSortAdapter: function(sortModelOrCollection, options) {
      return new SortAdapter(sortModelOrCollection, options);
    },

    bindPaginationMenuToPage: function(paginationMenu, spfHelper) {
      paginationMenu.visible = true;
      paginationMenu.model                = spfHelper.paginate;
      paginationMenu.bindings.currentPage = Paginate.PAGE;
      paginationMenu.bindings.totalPages  = Paginate.TOTAL_PAGES;
      return paginationMenu;
    },

    bindDropdownToSize: function(dropdown, spfHelper, sizes) {
      dropdown.visible = true;
      dropdown.collection = new Backbone.Collection(sizes || [{size: 5},{size: 10},{size: 25},{size: 50}]);
      dropdown.childBindings.text = 'size';

      function applyPageSize() {
        var selectedItem = dropdown.collection.findWhere({ size: spfHelper.paginate.get(Paginate.SIZE) });

        if (selectedItem) {
          dropdown.text = selectedItem.get('size') + ' per page';
          dropdown.value = selectedItem;
        } else {
          dropdown.text = '';
          dropdown.value = null;
        }
      };

      applyPageSize.call();

      dropdown.listenTo(spfHelper.paginate, 'change:' + Paginate.SIZE, applyPageSize)

      dropdown.listenTo(dropdown, 'change:value', function() {
        if (dropdown.value) {
          spfHelper.paginate.set(Paginate.SIZE, dropdown.value.get(Paginate.SIZE));
        } else {
          spfHelper.paginate.unset(Paginate.SIZE);
        }
      });

      return dropdown;
    },

    bindTextToItemCount: function(text, spfHelper) {
      function applyItemCount() {
        var model          = spfHelper.paginate,
            page           = model.get(Paginate.PAGE),
            totalItem      = Number(model.get(Paginate.TOTAL_ITEMS)),
            // get the item start index
            itemStartIndex = (Number(page)-1) * Number(model.get(Paginate.SIZE)) + 1,
            // get the item end index
            itemEndIndex   = Math.min(Number(model.get(Paginate.TOTAL_ITEMS)), itemStartIndex + Number(model.get(Paginate.SIZE))-1),
            // put it all together!
            title          = String(Math.min(itemStartIndex, totalItem)) + '-' + String(itemEndIndex) + ' of ' + String(totalItem);

        if (_.isNaN(itemStartIndex) || _.isNaN(itemEndIndex)) {
          text.text = '';
        } else {
          text.text = title;
        }
      };
      text
          .listenTo(spfHelper.paginate, 'change:' + Paginate.TOTAL_ITEMS + ' change:' + Paginate.SIZE + ' change:' + Paginate.PAGE, applyItemCount)
    },

    bindTableToSort: function(table, spfHelper) {
      table.model              = spfHelper.sort;
      table.bindings.sortField = Sort.SORT_FIELD;
      table.bindings.sortDir   = Sort.SORT_DIRECTION;
      return table;
    }

  };
  module.exports = PaginationUtil;
});
